import {BrowserNotSupportedController} from './browser-not-supported.controller';
import {BrowserInfo} from './browser-not-supported.state';
import {getRootStore} from '../../app.bootstrap';
import {IRouteStore} from '../../router/routing.infra';
import {ILocalizationService} from '../../services/LocalizationService';

export interface IBrowserNotSupportedStore extends IRouteStore {
    browserNotSupportedController: BrowserNotSupportedController;
    localizationService: ILocalizationService;
    dispose(): void;
}

export class BrowserNotSupportedStore implements IBrowserNotSupportedStore {
    public browserNotSupportedController: BrowserNotSupportedController;
    public localizationService: ILocalizationService;

    constructor(browserInfo: BrowserInfo | null, userName: string) {
        const rootStore = getRootStore();
        const {localizationService, tsLocaleHelper, environmentService, displayTabletAsDesktop, appState} = rootStore;

        appState.browserNotSupportedState.browserInfo = browserInfo;
        appState.browserNotSupportedState.userName = userName;

        this.localizationService = localizationService;
        this.browserNotSupportedController = new BrowserNotSupportedController(
            localizationService.translate,
            tsLocaleHelper,
            environmentService,
            displayTabletAsDesktop,
            appState.browserNotSupportedState
        );
    }

    dispose(): void {}
}
